var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilizationPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pattern",
    width: 209,
    height: 181,
    viewBox: "0 0 209 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circleClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 90.5,
    r: 80
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 0 L 0 0 0 10",
    fill: "none",
    stroke: "#1422BD",
    strokeWidth: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#circleClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 60L80 55L115 65L150 50L175 70",
    stroke: "#1422BD",
    strokeWidth: 0.8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 90L75 85L110 95L145 80L180 90",
    stroke: "#1422BD",
    strokeWidth: 0.8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 120L85 115L120 125L155 110L185 120",
    stroke: "#1422BD",
    strokeWidth: 0.8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 75L90 85",
    stroke: "#1422BD",
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 85L130 90",
    stroke: "#1422BD",
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 90L165 95",
    stroke: "#1422BD",
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 75L130 90",
    stroke: "#1422BD",
    strokeWidth: 0.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 85L165 95",
    stroke: "#1422BD",
    strokeWidth: 0.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 40L70 140",
    stroke: "#1422BD",
    strokeWidth: 0.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 30L104.5 150",
    stroke: "#1422BD",
    strokeWidth: 0.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 35L140 145",
    stroke: "#1422BD",
    strokeWidth: 0.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L160 130",
    stroke: "#1422BD",
    strokeWidth: 0.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 50L50 130",
    stroke: "#1422BD",
    strokeWidth: 0.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 75,
    r: 1.5,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 85,
    r: 1.5,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 90,
    r: 1.5,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 95,
    r: 1.5,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 105,
    r: 1,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 110,
    r: 1,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 105,
    r: 1,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 65,
    r: 1,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 70,
    r: 1,
    fill: "#1422BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 90.5,
    r: 50,
    stroke: "#1422BD",
    strokeWidth: 0.2,
    fill: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 90.5,
    r: 70,
    stroke: "#1422BD",
    strokeWidth: 0.15,
    fill: "none",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizationPattern);
export default __webpack_public_path__ + "static/media/utilization-pattern.7f861e3f02be0f66b5777ca408814a84.svg";
export { ForwardRef as ReactComponent };